export default {
  getCurrentStep: state => state.currentStep,
  getUuid: state => state.uuid,
  getIsEditing: state => state.isEditing,
  getRole: state => state.role,
  getName: state => state.role.name,
  getLevel: state => state.role.level,
  getCategory: state => state.role.category,
  getActive: state => state.role.active,
  getSearchable: state => state.role.searchable,
  getAccessControl: state => state.role.accessControl,
  getCanSell: state => state.role.canSell,
  getAccessWithoutGeolocation: state => state.role.accessWithoutGeolocation,
  getPermissions: state => state.permissions,
  getMenuPermissions: state => state.menuPermissions,
  getHomePermissions: state => state.homePermissions,
  getPermissionsOptions: state => state.permissionsOptions,
  getMenuPermissionsOptions: state => state.menuPermissionsOptions,
  getHomePermissionsOptions: state => state.homePermissionsOptions,
  getReportPermissionsOptions: state => state.reportPermissionsOptions
}
